import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";

export const SwipeableTaskCard = ({ task, children, onDelete, onClick, canDelete = false }) => {
    const [showDelete, setShowDelete] = useState(false);

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (canDelete) setShowDelete(true);
        },
        onSwipedRight: () => setShowDelete(false),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
        delta: 20, // minimum swipe distance in pixels to trigger
    });

    return (
        <div
            {...handlers}
            style={{
                position: "relative",
                marginBottom: 8,
                touchAction: "pan-y",
                userSelect: "none",
            }}
        >
            {/* Card slides left when showDelete is true */}
            <div
                style={{
                    transform: showDelete ? "translateX(-80px)" : "translateX(0)",
                    transition: "transform 0.3s ease",
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick && onClick();
                }}
            >
                {children}
            </div>

            {/* Render Delete button only when swiped */}
            {showDelete && (
                <div
                    style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: 80,
                        backgroundColor: "red",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        cursor: "pointer",
                        borderRadius: 4,
                        pointerEvents: showDelete ? "auto" : "none",
                        transition: "opacity 0.3s ease",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete && onDelete(task.id);
                        setShowDelete(false);
                    }}
                >
                    Delete
                </div>
            )}
        </div>
    );
};
